import type { ReactElement } from 'react'
import styled from 'styled-components'

import { MediaList } from './MediaList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

import type { Exposure } from '@/types/exposure'

type Props = {
  mediaExposureList: readonly Exposure[]
  mediaTypeList: readonly string[]
}

export const ExposurePage = ({ mediaExposureList, mediaTypeList }: Props) => {
  return (
    <Wrapper>
      <SectionTitle
        titleText="Media Exposure List"
        subTitleText="メディア露出一覧"
        color="normal"
      />
      <Spacer h={{ sp: 50, pc: 50 }} />
      <MediaList
        mediaExposureList={mediaExposureList}
        mediaTypeList={mediaTypeList}
      />
    </Wrapper>
  )
}

ExposurePage.getLayout = function getLayout(page: ReactElement) {
  const pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'ニュースルーム', path: '/news/' },
    { name: 'メディア露出一覧', path: '' },
  ]

  return (
    <>
      <Head
        title="メディア露出一覧"
        description="トライアルホールディングスが掲載された新聞記事、テレビ番組、雑誌などのメディアコンテンツをリストアップしています。"
        ogp={{ url: 'news/exposure/' }}
      />
      <TitleLayout {...pageTitle} breadCrumbs={breadCrumbs}>
        {page}
      </TitleLayout>
    </>
  )
}

const Wrapper = styled.div`
  width: 1045px;
  margin: 0 auto;
  padding: 70px 0 130px;

  @media screen and (max-width: 1047px) {
    width: 100%;
    padding: 40px 20px 80px;
  }
`
